/* @noflow FIXME */
import {
  CARIBBEAN,
  CHART_AXIS_FILL,
  CHART_BAR_SIZE,
  CHART_GRID_COLOR,
  CHART_HEIGHT,
  CHART_HEIGHT_SIMPLE,
  CHART_LEGEND_ALIGN,
  CHART_LEGEND_ICON_SIZE,
  CHART_MARGIN,
  CHART_MARKER_LEGEND_TYPE,
  SKY,
  VIOLET,
} from 'admin/constants/Charts';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import * as React from 'react';
import pluralize from 'pluralize';

import Row from 'components/Row.jsx';
import AdminStatisticsChartTooltip from 'admin/components/AdminStatisticsChartTooltip.jsx';
import AdminStatisticsChartTooltipValue from 'admin/components/AdminStatisticsChartTooltipValue.jsx';
import AdminStatisticsChartXAxisTick from 'admin/components/AdminStatisticsChartXAxisTick.jsx';
import Text from 'components/Text.jsx';

type Props = {
  data: Array<Object>,
  simple?: boolean,
  teachers?: boolean,
};

function StatisticsTeachersReachChartTooltip(
  // $FlowIssue
  props: { active: boolean, label: string, payload: Array }
) {
  const { active } = props;

  if (!active) {
    return null;
  }

  const { label, payload } = props;

  return (
    <AdminStatisticsChartTooltip title={label}>
      <StatisticsStudentsParentsReachChartTooltipValue
        action="sent"
        label={payload[0].name}
        value={payload[0].value}
      />
    </AdminStatisticsChartTooltip>
  );
}

function StatisticsStudentsParentsReachChartTooltip(
  // $FlowIssue
  props: { active: boolean, label: string, payload: Array }
) {
  const { active } = props;

  if (!active) {
    return null;
  }

  const { label, payload } = props;

  return (
    <AdminStatisticsChartTooltip title={label}>
      <Row size="small">
        <StatisticsStudentsParentsReachChartTooltipValue
          action="received"
          label={payload[0].name}
          value={payload[0].value}
        />
      </Row>
      <StatisticsStudentsParentsReachChartTooltipValue
        action="received"
        label={payload[1].name}
        value={payload[1].value}
      />
    </AdminStatisticsChartTooltip>
  );
}

function StatisticsStudentsParentsReachChartTooltipValue(props: {
  action: string,
  label: string,
  value: number,
}) {
  const { action, label, value } = props;

  return (
    <div>
      <AdminStatisticsChartTooltipValue element="div">
        {value.toLocaleString()}
      </AdminStatisticsChartTooltipValue>
      {pluralize(label, value)} <Text weight="semibold">{action}</Text> messages
    </div>
  );
}

function AdminStatisticsReachChart(props: Props) {
  const { data, simple, teachers } = props;

  return (
    <div className="AdminStatisticsReachChart">
      <ResponsiveContainer width="100%" height={simple ? CHART_HEIGHT_SIMPLE : CHART_HEIGHT}>
        <BarChart barGap={0} data={data} margin={CHART_MARGIN}>
          {!simple && (
            <XAxis
              axisLine={false}
              dataKey="Date"
              // $FlowIssue
              tick={<AdminStatisticsChartXAxisTick />}
              tickLine={false}
            />
          )}
          {!simple && (
            <YAxis
              allowDecimals={false}
              axisLine={false}
              tick={{ fill: CHART_AXIS_FILL }}
              tickLine={false}
            />
          )}
          {!simple && <CartesianGrid stroke={CHART_GRID_COLOR} vertical={false} />}
          {!simple && (
            <Tooltip
              content={
                !teachers ? (
                  // $FlowIssue
                  <StatisticsStudentsParentsReachChartTooltip />
                ) : (
                  // $FlowIssue
                  <StatisticsTeachersReachChartTooltip />
                )
              }
              isAnimationActive={false}
            />
          )}
          {!simple && <Legend align={CHART_LEGEND_ALIGN} iconSize={CHART_LEGEND_ICON_SIZE} />}
          {(simple || teachers) && (
            <Bar
              barSize={CHART_BAR_SIZE}
              dataKey="Teachers"
              fill={SKY}
              legendType={CHART_MARKER_LEGEND_TYPE}
            />
          )}
          {!teachers && (
            <Bar
              barSize={CHART_BAR_SIZE}
              dataKey="Students"
              fill={VIOLET}
              legendType={CHART_MARKER_LEGEND_TYPE}
            />
          )}
          {!teachers && (
            <Bar
              barSize={CHART_BAR_SIZE}
              dataKey="Parents"
              fill={CARIBBEAN}
              legendType={CHART_MARKER_LEGEND_TYPE}
            />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AdminStatisticsReachChart;
